<template>
  <v-app-bar app color="black" dark flat>
    <v-btn>
      <v-icon color="red" left class="mr-2">fas fa-signature</v-icon> Augusto
    </v-btn>

    <v-spacer></v-spacer>
    <v-btn text @click="scroll('home')" class="text-red">Inicio</v-btn>
    <v-btn text @click="scroll('about')">Sobre</v-btn>
    <v-btn text @click="scroll('projetos')">Projetos</v-btn>
    <v-btn text @click="scroll('contact')">Contatos</v-btn>
  </v-app-bar>
</template>

  <script>
export default {
  methods: {
    scroll(refName) {
      const element = document.getElementById(refName);
      element.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

  <style>
</style>
